import CTASection from '@/components/CTASection';
import FeaturesSection from '@/components/FeaturesSection';
import Footer from '@/components/Footer';
import HeroSection from '@/components/HeroSection';
import Navbar from '@/components/Navbar';
import { animationConfig, getPageAnimation } from '@/config/animations';
import { motion } from 'framer-motion';

const HomePage = () => {
  const AnimationWrapper = animationConfig.enablePageTransitions ? motion.div : 'div';

  return (
    <AnimationWrapper
      {...getPageAnimation()}
      className="min-h-screen bg-gradient-to-b from-dark-950 via-dark-900 to-dark-950"
    >
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <CTASection />
      <Footer />
    </AnimationWrapper>
  );
};

export default HomePage;